import {
  FilterMode,
  PaymentReceiptTypeCreateMutationVariables,
  PaymentReceiptType_OrderBy,
  PaymentReceiptType,
  SortOrder,
  PaymentReceiptType_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { fieldByLang } from "../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const paymentReceiptTypeService = {
  createOne: buildCreateOne(
    (
        paymentReceiptTypeCreateVariables: PaymentReceiptTypeCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.paymentReceiptTypeCreate(
          paymentReceiptTypeCreateVariables
        );
        return result.paymentReceiptTypeCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.paymentReceiptTypeOne({ id });
    return result.paymentReceiptTypeOne as PaymentReceiptType;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    language: string = "es",
    orderBy: PaymentReceiptType_OrderBy[] | null = null,
    filter: PaymentReceiptType_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: PaymentReceiptType_Filter | undefined;
    if (searchValue !== "") {
      where = {
        [fieldByLang("name", language)]: {
          contains: searchValue,
          mode: FilterMode.Insensitive,
        },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.paymentReceiptTypeListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ [fieldByLang("name", language)]: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.paymentReceiptTypeListWithOffset
    ) as PaymentReceiptType[];
    return { list, orderBy };
  },
};
